<template>
  <div
    :class="[
      'flex items-center gap-3.5',
      isSidebarOpen ? 'w-full justify-center' : 'justify-start'
    ]"
  >
    <div class="flex items-center space-x-3 max-sm:ml-10">
      <div
        class="flex hidden h-12 w-12 items-center justify-center rounded-full border border-gray-200 bg-white
          shadow-sm sm:flex sm:h-14 sm:w-14"
      >
        <div
          v-if="props.usedBy === 'QUESTIONNAIRE'"
          class="text-center font-[Inter] text-xs font-semibold leading-normal tracking-tight text-gray-800
            sm:text-sm"
        >
          {{ capitalizedFirstLetter(title) }}
        </div>
        <svg
          v-if="props.usedBy === 'PDF'"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="vuesax/bold/document-text">
            <g id="document-text">
              <path
                id="Vector"
                d="M16 2.16663H8C4.5 2.16663 3 4.16663 3 7.16663V17.1666C3 20.1666 4.5 22.1666 8 22.1666H16C19.5 22.1666 21 20.1666 21 17.1666V7.16663C21 4.16663 19.5 2.16663 16 2.16663ZM8 12.4166H12C12.41 12.4166 12.75 12.7566 12.75 13.1666C12.75 13.5766 12.41 13.9166 12 13.9166H8C7.59 13.9166 7.25 13.5766 7.25 13.1666C7.25 12.7566 7.59 12.4166 8 12.4166ZM16 17.9166H8C7.59 17.9166 7.25 17.5766 7.25 17.1666C7.25 16.7566 7.59 16.4166 8 16.4166H16C16.41 16.4166 16.75 16.7566 16.75 17.1666C16.75 17.5766 16.41 17.9166 16 17.9166ZM18.5 9.41663H16.5C14.98 9.41663 13.75 8.18663 13.75 6.66663V4.66663C13.75 4.25663 14.09 3.91663 14.5 3.91663C14.91 3.91663 15.25 4.25663 15.25 4.66663V6.66663C15.25 7.35663 15.81 7.91663 16.5 7.91663H18.5C18.91 7.91663 19.25 8.25663 19.25 8.66663C19.25 9.07663 18.91 9.41663 18.5 9.41663Z"
                fill="#292D32"
              />
            </g>
          </g>
        </svg>
      </div>
      <div
        class="inline-flex flex-col items-start justify-start gap-1 truncate sm:gap-2 sm:text-ellipsis"
      >
        <div
          class="font-[Inter] text-base font-semibold text-black max-sm:text-sm max-sm:font-bold sm:text-lg"
        >
          {{ title }}
        </div>
      </div>
    </div>
    <button
      v-if="!isExternal && !isPreviewRoute"
      class="absolute left-4 top-1/2 flex -translate-y-1/2 transform items-center gap-1.5 sm:left-6 md:left-8"
      @click="navigateToHome"
    >
      <div class="flex h-6 w-6 items-center justify-center">
        <BackIcon />
      </div>
      <div
        class="text-center font-[Inter] text-xs font-semibold tracking-tight text-black sm:text-sm"
      >
        zurück
      </div>
    </button>
  </div>
</template>

<script setup lang="ts">
  import BackIcon from '@/components/icons/backIcon.vue'
  import { useRouter, useRoute } from 'vue-router'
  import { computed } from 'vue'

  function capitalizedFirstLetter(word: string) {
    if (!word) return ''
    return word[0].toUpperCase()
  }

  const router = useRouter()
  const route = useRoute()

  const isPreviewRoute = computed(() => {
    return route.path.includes('/preview/')
  })

  function navigateToHome() {
    router.push({
      path: '/client/portal',
      query: { access_token: route.query.access_token?.toString() || '' }
    })
  }

  const props = defineProps({
    title: {
      type: String,
      default: ''
    },
    usedBy: {
      type: String,
      default: ''
    },
    isExternal: {
      type: Boolean,
      default: false
    },
    isSidebarOpen: {
      type: Boolean,
      default: true
    }
  })
</script>
